import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BatchLine } from 'app/_models/batch-line';
import { HttpErrorHandler } from 'app/shared/http-error-handler';
import { QuotaItem } from 'app/_models/quota-item';
import { QuotaMovementsBatch } from 'app/_models/quota-movements-batch';
import { Form } from 'app/shared/form';
import { ActivatedRoute } from '@angular/router';
import { ChoicesModel } from 'app/_models/choices-model';

interface QuotaCatalogData {
  id: string;
  label: string;
  quotas: QuotaItem[];
}

@Component({
  selector: 'app-quota-transfer-target-form',
  templateUrl: './quota-transfer-target-form.component.html',
  styleUrls: ['./quota-transfer-target-form.component.css'],
})
export class QuotaTransferTargetFormComponent extends Form implements OnInit {
  @Input() protected batchLine: BatchLine;
  @Input() protected batch: QuotaMovementsBatch;
  @Input() protected source: boolean;
  @Input() protected mode: string; // origin or destination
  @Input() protected form: any;
  @Input() protected quotas: QuotaItem[];
  @Input() protected targetModes: any[];
  @Output() protected quotaSelectedCallback = new EventEmitter<QuotaItem>();

  public quotaShip: string;
  public shipsEntities: any[];
  public filteredStockQuotas: any[];
  public quotaCatalog: { [id: string]: QuotaCatalogData } = {};

  constructor(protected route: ActivatedRoute, protected httpErrorHandler: HttpErrorHandler) {
    super(route, httpErrorHandler);
  }

  public ngOnInit() {
    this.createCatalog(this.quotas);
    this.shipsEntities = this.parseCatalog();
  }

  public shipSelect() {
    this.filterStockQuotas();
  }

  public quotaSelected() {
    if (this.source) {
      this.quotaSelectedCallback.emit(this.batchLine[`quota_${this.mode}`]);
    }
  }

  private filterStockQuotas() {
    this.filteredStockQuotas = [];
    if (this.quotaCatalog && this.quotaCatalog[this.quotaShip]) {
      this.filteredStockQuotas = this.parseDropdownResults(this.quotaCatalog[this.quotaShip].quotas, new QuotaItem(), 'stockLabel');
    }
  }

  private createCatalog(quotas: QuotaItem[]) {
    this.quotaCatalog = {};
    for (const quota of quotas) {
      let id = '';
      let label = '';

      if (quota.quota_type === 'individual') {
        id = String(quota.ships[0].id);
        label = String(quota.ships[0].name);
      } else {
        id = quota.name;
        label = quota.name;
      }

      if (this.quotaCatalog[id]) {
        this.quotaCatalog[id].quotas.push(quota);
      } else {
        this.quotaCatalog[id] = {
          id: id,
          label: label,
          quotas: [],
        };
        this.quotaCatalog[id].quotas.push(quota);
      }
    }
  }

  private parseCatalog() {
    const collection = [];
    collection.push({ label: '', value: null });

    Object.keys(this.quotaCatalog).forEach((key) => {
      collection.push({ label: this.quotaCatalog[key].label, value: this.quotaCatalog[key].id });
    });

    return collection;
  }
}



// WEBPACK FOOTER //
// ./src/app/quotas/quota-batchs/components/quota-transfer-target-form/quota-transfer-target-form.component.ts